import React from 'react';

const ExportDefault = () => <div>no template available</div>;  
export default ExportDefault;
